// extracted by mini-css-extract-plugin
export default {"root":"UploadPage_root__NY-04"};